import { CS } from '../../../base/utils/styler'

export const baseStyle: CS = {
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    color: 'white',
    border: 'none',
    padding: '15px 30px',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
    width: '200px',
    textAlign: 'center',
    userSelect: 'none',
    marginBottom: '10px',
    // shadowbox bottom
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    '&:hover':  {
        filter: 'contrast(1.2)',
    },
    '&:active': {
        transform: 'translateY(1px)',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    '&:disabled': {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
}